var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 12,
    viewBox: "0 0 23 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1717 8.38708H7.6277L4.8197 3.77108V8.38708H4.2917V2.87508H4.8597L7.6437 7.45908V2.87508H8.1717V8.38708ZM11.1701 8.46708C10.1061 8.46708 9.28214 7.69108 9.28214 6.50708C9.28214 5.32308 10.1061 4.57108 11.1701 4.57108C12.2341 4.57108 13.0021 5.32308 13.0021 6.50708C13.0021 6.59508 13.0021 6.68308 12.9941 6.75508H9.82614C9.91414 7.48308 10.4821 7.93908 11.1701 7.93908C11.6821 7.93908 12.1061 7.69908 12.3381 7.29108C12.4981 7.33108 12.7061 7.37108 12.8741 7.41108C12.5621 8.08308 11.9301 8.46708 11.1701 8.46708ZM9.82614 6.25908H12.4581C12.3541 5.54708 11.8661 5.09908 11.1701 5.09908C10.4661 5.09908 9.93014 5.54708 9.82614 6.25908ZM18.0968 8.38708H17.6488L16.4888 5.38708L15.3688 8.38708H14.9208L13.4808 4.65108H14.0488L15.1288 7.53908L16.2008 4.65108H16.7768L17.8568 7.53908L18.9288 4.65108H19.4968L18.0968 8.38708Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.728027,
    y: 0.613525,
    width: 21.7461,
    height: 10.8174,
    stroke: "#E1E1E1",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.bd59b8e595905725429af503fc1fb744.svg";
export { ForwardRef as ReactComponent };